/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

    document.addEventListener('DOMContentLoaded', function () {
    const placeholderText = 'Select condition';  // similar to dropdown text

    document.querySelectorAll('popout-select').forEach(function (popout) {
      const toggleText = popout.querySelector('[data-popout-toggle-text]');
      const input = popout.querySelector('[data-popout-input]');

      if (!toggleText || !input) return;
      if (toggleText.textContent.trim() !== placeholderText) return;

      const productContainer = popout.closest('[data-section-type]');
      if (!productContainer) return;

      const atcButton = productContainer.querySelector('[data-add-to-cart]');
      const atcText = productContainer.querySelector('[data-add-to-cart-text]');

      if (!atcButton || !atcText) return;

      function updateChooseVariantState() {
        if (input.value === '') {
          atcButton.disabled = true;
          atcText.textContent = placeholderText;
        }
      }

      updateChooseVariantState();

      input.addEventListener('change', function () {
        setTimeout(updateChooseVariantState, 0);
      });
    });
  });




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
